/* Shannonty Home — storefront behaviour (no dependencies) */
(function () {
  'use strict';

  var routes = (window.theme && window.theme.routes) || { cartAdd: '/cart/add.js', cart: '/cart' };

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!button) return;
    var input = button.parentElement.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var value = parseInt(input.value || '0', 10) || 0;
    value = button.hasAttribute('data-qty-plus') ? value + 1 : Math.max(min, value - 1);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Mobile menu: close on Escape ---------- */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('details.mobile-menu[open]').forEach(function (menu) {
      menu.removeAttribute('open');
      menu.querySelector('summary').focus();
    });
  });

  /* ---------- Cart: auto-update when a quantity changes ---------- */
  document.querySelectorAll('[data-cart-form]').forEach(function (form) {
    form.addEventListener('change', function (event) {
      if (!event.target.matches('[data-cart-qty]')) return;
      var update = form.querySelector('[name="update"]');
      if (form.requestSubmit && update) form.requestSubmit(update);
      else form.submit();
    });
  });

  /* ---------- Product configurator ---------- */
  document.querySelectorAll('[data-product-form]').forEach(initProductForm);

  function initProductForm(form) {
    var section = form.closest('[data-product-section]');
    var idInput = form.querySelector('[data-variant-id]');
    var submit = form.querySelector('[type="submit"]');
    var errorBox = form.querySelector('[data-form-error]');
    var productData = null;
    var jsonEl = section && section.querySelector('[data-product-json]');
    if (jsonEl) {
      try { productData = JSON.parse(jsonEl.textContent); } catch (e) { productData = null; }
    }

    // Variant picker (only when the product has real Shopify variants)
    var variantSelects = form.querySelectorAll('[data-variant-option]');
    if (variantSelects.length && productData) {
      variantSelects.forEach(function (select) {
        select.addEventListener('change', function () { updateVariant(); });
      });
    }

    function updateVariant() {
      var chosen = Array.prototype.map.call(variantSelects, function (s) { return s.value; });
      var match = productData.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
      if (!match) {
        submit.disabled = true;
        return;
      }
      idInput.value = match.id;
      submit.disabled = !match.available;
      var price = section.querySelector('[data-variant-price]');
      if (price) price.textContent = formatMoney(match.price);
      if (match.featured_media && section) {
        var thumb = section.querySelector('[data-media-id="' + match.featured_media.id + '"]');
        if (thumb) thumb.click();
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }

    // Swatches that drive a linked select / radio group
    form.querySelectorAll('[data-swatch]').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var group = swatch.closest('[data-swatch-group]');
        var target = group && group.getAttribute('data-linked-option');
        var value = (swatch.getAttribute('data-swatch') || '').toLowerCase();
        group.querySelectorAll('[data-swatch]').forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
        swatch.setAttribute('aria-pressed', 'true');
        if (!target) return;
        var control = form.querySelector('[data-option-label="' + cssEscape(target) + '"]');
        if (!control) return;
        if (control.tagName === 'SELECT') {
          var option = Array.prototype.find.call(control.options, function (o) {
            var text = o.text.toLowerCase();
            return o.value && (value.indexOf(text) === 0 || text.indexOf(value) === 0);
          });
          if (option) {
            control.value = option.value;
            control.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else {
          control.querySelectorAll('input').forEach(function (input) {
            var text = input.value.toLowerCase();
            if (value.indexOf(text) === 0 || text.indexOf(value) === 0) input.checked = true;
          });
        }
      });
    });

    // Keep swatches in sync when the linked select changes
    form.querySelectorAll('[data-swatch-group]').forEach(function (group) {
      var target = group.getAttribute('data-linked-option');
      var control = target && form.querySelector('select[data-option-label="' + cssEscape(target) + '"]');
      if (!control) return;
      control.addEventListener('change', function () {
        var text = control.options[control.selectedIndex] ? control.options[control.selectedIndex].text.toLowerCase() : '';
        group.querySelectorAll('[data-swatch]').forEach(function (s) {
          var v = (s.getAttribute('data-swatch') || '').toLowerCase();
          s.setAttribute('aria-pressed', text && control.value && (v.indexOf(text) === 0 || text.indexOf(v) === 0) ? 'true' : 'false');
        });
      });
    });

    // Submit: add configured item (+ any add-on service) to the bag, then go to the bag
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (errorBox) errorBox.textContent = '';
      if (!form.reportValidity()) return;

      var data = new FormData(form);
      var properties = {};
      data.forEach(function (value, key) {
        var m = key.match(/^properties\[(.+)\]$/);
        if (m && String(value).trim() !== '') properties[m[1]] = value;
      });

      var quantity = parseInt(data.get('quantity') || '1', 10) || 1;
      var items = [{ id: parseInt(idInput.value, 10), quantity: quantity, properties: properties }];

      form.querySelectorAll('input[data-addon-variant]:checked').forEach(function (input) {
        var addonId = parseInt(input.getAttribute('data-addon-variant'), 10);
        if (addonId) {
          items.push({ id: addonId, quantity: 1, properties: { 'For': form.getAttribute('data-product-title') || '' } });
        }
      });

      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');

      fetch(routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          return response.json().then(function (json) { return { ok: response.ok, json: json }; });
        })
        .then(function (result) {
          if (!result.ok) throw new Error(result.json.description || result.json.message || 'Could not add to bag.');
          window.location.href = routes.cart;
        })
        .catch(function (err) {
          if (errorBox) errorBox.textContent = err.message;
          submit.disabled = false;
          submit.removeAttribute('aria-busy');
        });
    });
  }

  /* ---------- Product gallery thumbnails ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        var srcset = thumb.getAttribute('data-srcset');
        var img = main.querySelector('img');
        if (img) {
          img.src = src;
          if (srcset) img.srcset = srcset;
          img.alt = thumb.getAttribute('data-alt') || '';
        }
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var amount = (cents / 100);
    var withDecimals = amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDecimals = Math.round(amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_no_decimals') return noDecimals;
      if (key === 'amount_with_comma_separator') return amount.toFixed(2).replace('.', ',');
      if (key === 'amount_no_decimals_with_comma_separator') return noDecimals.replace(/,/g, '.');
      return withDecimals;
    });
  }

  function cssEscape(value) {
    return window.CSS && CSS.escape ? CSS.escape(value) : String(value).replace(/"/g, '\\"');
  }
})();
